module.exports = __webpack_public_path__ + "img/91logo.84464c4a.png";